import { AlertTriangle, Loader2, QrCode, X } from 'lucide-react'
import type { CanalConexao, CanalEstado } from '@/services/atendimento'

export default function QrPairingModal({
  canal, estado, qr, souTitular, onClose,
}: {
  canal: CanalConexao
  estado: CanalEstado | null
  qr: string | null
  souTitular: boolean
  onClose: () => void
}) {
  return (
    <div
      role="dialog" aria-modal="true" aria-label="Pareamento por QR"
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15, 23, 32, .45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 16,
      }}
      onClick={onClose}
    >
      <div
        className="card"
        style={{ width: '100%', maxWidth: 420, padding: 20, display: 'flex', flexDirection: 'column', gap: 12 }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <strong style={{ fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            <QrCode size={17} aria-hidden style={{ color: 'var(--primary)' }} />
            Pareamento por QR
            {estado && (
              <span className={`badge ${estado.worker_online ? 'badge-ok' : 'badge-warn'}`} style={{ fontSize: 11 }}>
                {estado.worker_online ? 'worker online' : 'worker offline'}
              </span>
            )}
          </strong>
          <button
            type="button" className="btn-secondary" aria-label="Fechar"
            style={{ minHeight: 32, width: 32, padding: 0, justifyContent: 'center' }}
            onClick={onClose}
          >
            <X size={15} aria-hidden />
          </button>
        </div>

        <div className="badge badge-warn" style={{ display: 'block', padding: '8px 12px' }}>
          <AlertTriangle size={14} aria-hidden style={{ verticalAlign: -2, marginRight: 6 }} />
          Conexão <strong>não-oficial</strong>: contraria os Termos da Meta e o número pode ser
          banido. Para comunicação clínica em volume, use a Cloud API.
        </div>

        {qr ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14, alignItems: 'center' }}>
            <img
              src={qr} alt="QR code para conectar o WhatsApp" width={240} height={240}
              style={{ borderRadius: 10, border: '1px solid var(--border)', background: '#fff' }}
            />
            <ol style={{ margin: 0, paddingLeft: 18, fontSize: 13.5, lineHeight: 1.8, color: 'var(--text-secondary)', alignSelf: 'stretch' }}>
              <li>No celular do consultório, abra o <strong>WhatsApp</strong>.</li>
              <li>Toque em <strong>Configurações → Dispositivos conectados</strong>.</li>
              <li>Toque em <strong>Conectar um dispositivo</strong> e aponte para este código.</li>
              <li>O código se renova sozinho a cada poucos segundos — não precisa recarregar a página.</li>
            </ol>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13.5, color: 'var(--text-secondary)', padding: '20px 0' }}>
            <Loader2 size={16} style={{ animation: 'spin 1s linear infinite' }} aria-hidden />
            {estado?.worker_online === false
              ? 'Worker sem sinal na VM. Confira o deploy: python3 deploy/deploy-worker-baileys.py --status'
              : estado?.qr_pendente && !souTitular
                ? 'Há um QR aguardando leitura — só o médico titular pode visualizá-lo.'
                : 'Aguardando o worker gerar o QR…'}
            <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
          </div>
        )}

        {estado?.ultimo_erro && (
          <p style={{ fontSize: 12.5, color: 'var(--danger)', margin: 0 }}>
            Último erro do worker: {estado.ultimo_erro}
          </p>
        )}

        {canal.worker_slug && (
          <p style={{ fontSize: 12, color: 'var(--muted)', margin: 0 }}>
            Processo na VM: <code>wpp-{canal.worker_slug}</code>
          </p>
        )}
      </div>
    </div>
  )
}
